module.exports = __webpack_public_path__ + "img/filter-search-icon.896d90b5.svg";